// extracted by mini-css-extract-plugin
export default {"container":"styles_container__00un-","title":"styles_title__lFNA6","faqTitle":"styles_faqTitle__Z8Vow","faqAnswer":"styles_faqAnswer__u8MF1"};